import useGetter from "./useGetter";
import Id from "./IdFactory";
import A from './ActionCreators';
import PublicationEditor from "./PublicationEditor";
import FilesystemContainer from "./FilesystemContainer";
import { useState } from 'react';
import ur from './ur';
import { useDispatch, useSelector } from 'react-redux';

export default function Publications(){

  const dispatch = useDispatch();
  const [ state, set ] = ur({})//publicationId:"pub0"});
  //really should just control publicationId... I don't know what else

  let { publicationId } = state;
  

  function onCreate(){

    let _id = Id();
    dispatch(
      A.createItem({
        itemType:"publications",
        _id,
      }))

    set({publicationId:_id});
  }

  return (
    <div style={{
    }} class="sg-row full-height flex-expand sg-row">
      <div style={{width:100}}>
        <div>
          The ideal UI/UX is likely drag'n'drop to place panels in order.
          <div>
            To put something to a lower number, you should get "virtual rows"
            and lower drag down the rows just keep coming and allow you to move as 
            far down as you want in the tree...

          </div>
        </div>
        <button onClick={onCreate} action={"new-publication" }>New publication</button>
        <FilesystemContainer setSelectedItem={(val) => set({publicationId:val._id})} selectedItem={{type:"publications", _id:publicationId}} root={"publications"}/>
      </div>

      <div class="flex-expand border-left">
        {publicationId && <PublicationEditor {...{
          publicationId,
        }}/>}
        {!publicationId && (
          <div style={{
            //border:'3px solid lime',
          }} class="sg-row flex-expand full-width full-height h-center v-center">
            <h5>Select a publication or <br/> <button onClick={onCreate} class="btn btn-link"><h5>create a new one</h5></button></h5>
          </div>
        )}
      </div>

    </div>

  )

}
